module.exports = __webpack_public_path__ + "img/inactive-account.a3883c9e.svg";